<template>
  <v-container fluid>
    <v-toolbar color="secondary" flat dense>
      <v-toolbar-title>Stock Valuation Report</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small text to="/stock-reports">
        <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
      </v-btn>
    </v-toolbar>

    <v-card>
      <v-card-text>
        <div>
      
          <v-row>
            <v-col cols="12">
              <download-excel :data="reportData" :fields="fields" :name="`Stock Value Report ${storeName}`">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>
            </v-col>
          </v-row>

          <v-row dense class="subtitle-2 text--primary">
            <v-col cols="6">
              <span>Total Stock Value (Buying Price): {{ stockValueBuying.toLocaleString() }}</span>
              <br />
              <span>Total Stock Value (Selling Price): {{ stockValueSelling.toLocaleString() }}</span>
            </v-col>

            <v-col cols="6">
              <v-btn class="float-right" text @click="generatePdfReport" color="accent">
                <v-icon color="black" left>mdi-file-pdf-box</v-icon> Print
                Pdf Report
              </v-btn>
            </v-col>
          </v-row>

          <v-row dense class="subtitle-2 text--primary">
            <v-col cols="12">
              <v-text-field v-model="search" label="Search"></v-text-field>
              <v-data-table :loading="isLoading" loading-text="Loading .... please wait" dense :headers="headers"
                :items="reportData" :search="search" :items-per-page="2000">
                <template v-slot:item.BuyingPrice="{ item }">
                  <span>{{ item.BuyingPrice | currency }}</span>
                </template>

                <template v-slot:item.SellingPrice="{ item }">
                  <span>{{ item.SellingPrice | currency }}</span>
                </template>

                <template v-slot:item.TotalRowBuyingPrice="{ item }">
                  <span>{{ item.TotalRowBuyingPrice | currency }}</span>
                </template>

                <template v-slot:item.TotalRowSellingPrice="{ item }">
                  <span>{{ item.TotalRowSellingPrice | currency }}</span>
                </template>
              </v-data-table>
              <!-- snackbar -->
              <snackbar ref="snackbar"></snackbar>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->


    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  data() {
    return {
      isLoading: false,
      record: {},
      search: null,
      reportData: [],
      stockValueBuying: 0,
      stockValueSelling: 0,
      headers: [
        { text: "ItemCode", value: "ItemCode" },
        { text: "Product", value: "Product" },
        { text: "Available Qty", value: "AvailableStock" },
        { text: "Inventory Unit", value: "BaseUnit" },
        { text: "Buying Price", value: "BuyingPrice" },
        { text: "Selling Price", value: "SellingPrice" },
        { text: "Row Total (buying)", value: "TotalRowBuyingPrice" },
        { text: "Row Total (Selling)", value: "TotalRowSellingPrice" }
      ],
      fields: {
        ItemCode: "ItemCode",
        Product: "Product",
        Quantity: "AvailableStock",
        BuyingPrice: "BuyingPrice",
        SellingPrice: "SellingPrice",
        TotalBuyingPrice: "TotalRowBuyingPrice",
        TotalSellingPrice: "TotalRowSellingPrice"
      },
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    stockValue() {
      let total = 0;
      if (this.reportData.StockValue) {
        total = this.reportData.StockValue.toLocaleString();
      }
      return total;
    },
    availableQty() {
      let total = 0;
      if (this.reportData.TotalAvailableQty) {
        total = this.reportData.TotalAvailableQty.toLocaleString();
      }
      return total;
    }
  },
  methods: {
    generatePdfReport() {
      var url = "/print-stock-value-report";
      const apiUrl = `${host}${url}`;

      const self = this;

      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    getReport() {
      const url = "/items-total-value";
      const self = this;
      self.isLoading = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData.StockData;
            self.stockValueBuying = res.ResponseData.TotalBuyingPriceValue;
            self.stockValueSelling = res.ResponseData.TotalSellingPriceValue;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        }).finally(() => {
          self.isLoading = false;
        });
    },
    print() { }
  },
  created() {
    this.getReport();
  }
};
</script>

<style lang="scss" scoped></style>